export default __webpack_public_path__ + "static/media/door-icon.ab083303.svg";